import { schema } from "normalizr";

export const regionSchema = new schema.Entity("regions");
